import * as z from "zod/v4";

/**
 * Admin RPC to retry the final "attach number to campaign" step for a
 * team whose brand + campaign + phone number are already in place. Used
 * when Telnyx rejected the PATCH transiently and ops needs to re-run it
 * without re-registering the whole brand/campaign.
 *
 * Requires `requireExplicitConfirm: true` (matches the guard on
 * triggerRecoverProvisioning) so accidental curl calls don't spend
 * retry budget or leave the merchant in a weird state.
 */
export const retryRecoverProfileAttach = {
  name: "retryRecoverProfileAttach" as const,
  input: z.object({ teamId: z.string(), requireExplicitConfirm: z.boolean() }),
  output: z.discriminatedUnion("status", [
    z.object({ status: z.literal("attached"), messagingProfileId: z.string() }),
    z.object({
      status: z.literal("blocked"),
      reason: z.enum([
        "confirmation-required",
        "team-not-found",
        "brand-not-verified",
        "campaign-not-verified",
        "number-not-ordered",
        "provider-error",
        "internal-error",
      ]),
      detail: z.string().optional(),
    }),
  ]),
};
